<template>
  <b-form action="">
    <div class="d-flex">
      <b-form-group
        id="input-group-date"
        label-for="date"
        description="Fecha del ingreso del ticket"
        label="Fecha"
        class="m-0"
      >
        <b-form-datepicker
          id="date"
          v-model="filtersB.date"
          placeholder="Fecha"
          :date-format-options="{
            year: 'numeric', month: 'short', day: '2-digit'
          }"
          locale="es"
          name="date"
        ></b-form-datepicker>
      </b-form-group>
      <b-form-group
        id="input-group"
        class="ml-2"
        :label="`\xa0`"
      >
        <b-button type="submit" variant="primary">Buscar</b-button>
      </b-form-group>
    </div>
    </b-form>
</template>
<script>
  export default {
    name:'SearchTicketsSeller',
    props:['filters'],
    data() {
      return {
        filtersB: this.filters
      }
    }
  }
</script>